import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type UiState = {
  loader: number;
  error: Error | null;
  megaMenuCategory:
    | 'KITCHEN'
    | 'LAUNDRY'
    | 'SMALL_APPLIANCES'
    | 'AIR'
    | 'ALL'
    | null;
};

const initialState: UiState = {
  loader: 0,
  error: null,
  megaMenuCategory: null,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    incrementLoader: state => {
      state.loader += 1;
    },
    decrementLoader: state => {
      state.loader = Math.max(0, state.loader - 1);
    },
    setError: (state, action: PayloadAction<Error>) => {
      state.error = action.payload;
    },
    openMegaMenu: (
      state,
      action: PayloadAction<UiState['megaMenuCategory']>
    ) => {
      state.megaMenuCategory = action.payload;
    },
    closeMegaMenu: state => {
      state.megaMenuCategory = null;
    },
  },
});

export const {
  incrementLoader,
  decrementLoader,
  setError,
  openMegaMenu,
  closeMegaMenu,
} = uiSlice.actions;
export default uiSlice;
